import React from 'react';
import { ButtonBase } from '@common/Component/Forms';
import { useRouter } from 'next/router';
import { MOUNJARO_HOME_ROUTE } from '@common/Utility/constants';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const NoPrescriptionMounjaro = ({shouldShowButtonOutline = false, sku=[]}) => {
    const router = useRouter();
    const generateURL = useNavigationURL();

    const onConsultNowClick = () => { 
      router.push({
        pathname: generateURL(MOUNJARO_HOME_ROUTE),
        query: {
          itemids: [sku].join(','),
        }
      });
    }

    return (
        <div className='mounjaro-container'>
            <div>
              <div className='no-prescription-header'>No prescription?</div>
              <span className='no-prescription-description'>Get your prescription with <b>FREE Instant video consultation</b></span>
            </div>

            <ButtonBase 
              text="Consult Now"
              variant={shouldShowButtonOutline ? 'outline-primary' : 'link'}
              customClass="me-0 consult-now-container"
              size="sm"
              minWidth="100px"
              onClick={onConsultNowClick}
            />
          </div>
    );
}

export default NoPrescriptionMounjaro;